(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/common/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/casino-react/common/assets/javascripts/utils.js');

'use strict';

let constants;
if (svs.isServer) {
  constants = require('./constants.es6');
} else {
  constants = svs.components.casino_react.common.constants;
}

const normalizeCardData = (model, type) => {
  if (!Object.values(constants.CardType).includes(type)) {
    throw new Error('Unsupported Card Type');
  }
  return Object.freeze({
    type,
    model
  });
};
function getSortingOptions() {
  let includeWinlines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const sortingOptions = [{
    name: 'Bästa träff',
    mode: 'default-asc'
  }, {
    name: 'Titel: A-Ö',
    mode: 'name-asc'
  }, {
    name: 'Titel: Ö-A',
    mode: 'name-desc'
  }, {
    name: 'RTP: stigande',
    mode: 'rtp-asc'
  }, {
    name: 'RTP: fallande',
    mode: 'rtp-desc'
  }];
  const slotsSpecificSortingOptions = [{
    name: 'Vinstlinjer: stigande',
    mode: 'winLines-asc'
  }, {
    name: 'Vinstlinjer: fallande',
    mode: 'winLines-desc'
  }];
  return includeWinlines ? sortingOptions.concat(slotsSpecificSortingOptions) : sortingOptions;
}
function defineSearchFilters(games) {
  const filters = {
    categories: {
      type: 'categories',
      title: 'Spelkategori',
      options: [{
        title: 'Slots'
      }, {
        title: 'Bordsspel'
      }, {
        title: 'Livespel'
      }]
    },
    tags: {
      type: 'tags',
      title: 'Spelfunktion',
      options: [{
        title: 'Freespins'
      }, {
        title: 'Re-spins'
      }, {
        title: 'Sticky Wilds'
      }, {
        title: 'Megaways'
      }]
    },
    providers: {
      type: 'providers',
      title: 'Leverantör',
      options: []
    }
  };
  const providers = {};
  Object.values(games).forEach(game => {
    if (game.provider && !providers[game.provider]) {
      providers[game.provider] = true;
      filters.providers.options.push({
        title: game.provider
      });
    }
  });
  filters.providers.options.sort((a, b) => a.title.localeCompare(b.title));
  return [filters.categories, filters.tags, filters.providers];
}
const isLiveTableClosed = liveData => {
  if (!liveData) {
    return false;
  }
  return liveData.gameState !== 1 && liveData.openHours && liveData.openHours.type !== 'FullTime';
};
const hasSeatsLeft = _ref => {
  let {
    provider,
    liveData
  } = _ref;
  if (provider === 'Playtech' && liveData !== null && liveData !== void 0 && liveData.seatsTaken && (liveData === null || liveData === void 0 ? void 0 : liveData.seats) > 0) {
    return true;
  }
  if (provider === 'Evolution' && liveData !== null && liveData !== void 0 && liveData.seatsTaken && liveData !== null && liveData !== void 0 && liveData.seats && (liveData === null || liveData === void 0 ? void 0 : liveData.seats) - (liveData === null || liveData === void 0 ? void 0 : liveData.seatsTaken.length) > 0) {
    return true;
  }
  return false;
};
const getSeatsLeft = _ref2 => {
  let {
    provider,
    liveData
  } = _ref2;
  if (!liveData) {
    return null;
  }
  switch (provider) {
    case 'Evolution':
      return liveData.seatsTaken ? liveData.seats - liveData.seatsTaken.length : null;
    case 'Playtech':
      if (liveData.seatsTaken) {
        return liveData.seatsTaken.filter(seat => seat === 1).length;
      }
      return null;
    default:
      return null;
  }
};
const rouletteBallColor = Object.freeze({
  '00': 'green',
  0: 'green',
  1: 'red',
  2: 'black',
  3: 'red',
  4: 'black',
  5: 'red',
  6: 'black',
  7: 'red',
  8: 'black',
  9: 'red',
  10: 'black',
  11: 'black',
  12: 'red',
  13: 'black',
  14: 'red',
  15: 'black',
  16: 'red',
  17: 'black',
  18: 'red',
  19: 'red',
  20: 'black',
  21: 'red',
  22: 'black',
  23: 'red',
  24: 'black',
  25: 'red',
  26: 'black',
  27: 'red',
  28: 'black',
  29: 'black',
  30: 'red',
  31: 'black',
  32: 'red',
  33: 'black',
  34: 'red',
  35: 'black',
  36: 'red'
});

const validCardRegex = new RegExp("^(".concat(Object.values(constants.CardType).join('|'), ")_[a-z0-9-]+$"));
const isValidCardName = cardNameWithType => validCardRegex.test(cardNameWithType);
const exported = {
  defineSearchFilters,
  isLiveTableClosed,
  getSeatsLeft,
  hasSeatsLeft,
  rouletteBallColor,
  getSortingOptions,
  normalizeCardData,
  isValidCardName
};
if (svs.isServer) {
  module.exports = exported;
} else {
  setGlobal('svs.components.casino_react.common.utils', exported);
}

 })(window);